import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export const PlusMinusIcon = (props: IconProps): ReactElement => (
  <IconWrapper {...props}>
    <circle cx="12" fill="none" stroke="currentColor" cy="12" r="9" strokeWidth="1" />
    <line className="plusMinus__horizontal" stroke="currentColor" strokeWidth="1" x1="9" y1="12" x2="15" y2="12" />
    <line className="plusMinus__vertical" stroke="currentColor" strokeWidth="1" x1="12" y1="9" x2="12" y2="15" />
  </IconWrapper>
);
